/**
 * @generated SignedSource<<b5f4909870aadba45b110b4f0b4e8cef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueTimelineSecondary$data = {
  readonly isTransferInProgress: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"IssueTypeAddedEventRationales">;
  readonly " $fragmentType": "IssueTimelineSecondary";
};
export type IssueTimelineSecondary$key = {
  readonly " $data"?: IssueTimelineSecondary$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueTimelineSecondary">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IssueTimelineSecondary",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isTransferInProgress",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "IssueTypeAddedEventRationales"
    }
  ],
  "type": "Issue",
  "abstractKey": null
};

(node as any).hash = "f924f03e9d36be8bd35e7d51f164a577";

export default node;
